import { useGetSettingsQuery } from "@/app/settingsApi";
import { useEffect } from "react";

const TESTING_MODE = import.meta.env.VITE_PLAYWRIGHT_TESTING_MODE === "true";

export function useClarity() {
  const { data: settings } = useGetSettingsQuery();

  useEffect(() => {
    if (settings?.clarityScript && !TESTING_MODE) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.text = settings.clarityScript;

      document.head.appendChild(script);
    }
  }, [settings?.clarityScript]);
}
